import { render } from "./DocumentClassForm.vue?vue&type=template&id=01b68e72&ts=true"
import script from "./DocumentClassForm.vue?vue&type=script&lang=ts"
export * from "./DocumentClassForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__